export const formatTimestamp = () => {
  const now = new Date()
  const pad = (n) => String(n).padStart(2, "0")
  return `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}`
}

export const formatDate = (isoString) =>
  new Date(isoString).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  })

export const downloadUrl = (url, filename) => {
  const link = document.createElement("a")
  link.href = url
  link.download = filename
  link.click()
}

export const downloadFile = (content, filename, type = "text/plain") => {
  const url = URL.createObjectURL(new Blob([content], { type }))
  downloadUrl(url, filename)
  URL.revokeObjectURL(url)
}
